<script setup lang="ts">

import TheBottomSheet from '@/components/TheBottomSheet.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import EggImage from '@/partners/lingo/lingo-giveaway/assets/images/egg.png'
import { T } from '@tolgee/vue'
import CountdownTag from '@/components/CountdownTag.vue'

defineProps<{
  show: boolean
  countDownSeconds: number
}>()
defineEmits(['hide'])
const oneDayInSeconds = 3600 * 24

</script>

<template>
  <TheBottomSheet
    :show="show"
    centered
    @hide="$emit('hide')"
    :close-button="false"
    content-class="pt-8"
  >
    <div class="w-full flex flex-col gap-y-8">
      <img
        :src="EggImage"
        class="h-20 w-auto object-contain"
      >
      <div class="flex flex-col items-center gap-y-3">
        <h2 class="text-2xl font-bold -tracking-[0.48px] text-solid-white text-center">
          Your egg is not ready yet
        </h2>
        <p class="text-white/60 whitespace-pre-line text-center font-semibold text-lg leading-7">
          Wait for the next hatch and level up in Dropee for extra chances to crack another egg instantly next time!
        </p>
      </div>
      <div class="flex flex-col items-center gap-y-3">
        <p class="text-base font-medium">
          Next egg hatches in:
        </p>
        <CountdownTag
          :cooldown="oneDayInSeconds"
          :remaining-time="countDownSeconds"
          chip-class="bg-dark-most-bottom-layer"
        />
      </div>
      <BaseButton
        class="w-full"
        @click="$emit('hide')"
      >
        <T
          key-name="lingo.giveaway.info.cta"
          default-value="Got it"
        />
      </BaseButton>
    </div>
  </TheBottomSheet>
</template>
